import { Box, Button, Typography, Paper, Alert } from '@mui/material'
import GoogleIcon from '@mui/icons-material/Google'
import { login } from '../services/auth'
import { useAuth } from '../contexts/AuthContext'
import { useEffect } from 'react'
import { usePageTitle } from '../hooks/usePageTitle'
import { APP_VERSION } from '../constants'

export default function Login() {
  usePageTitle('Login', '', true)
  const { error, loading } = useAuth()

  const handleLogin = () => {
    login('/')
  }

  // Check for error from URL params (redirected from backend)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const errorParam = urlParams.get('error')
    if (errorParam) {
      console.error('Authentication error:', errorParam)
    }
  }, [])

  const urlParams = new URLSearchParams(window.location.search)
  const errorFromUrl = urlParams.get('error')
  const displayError = error || errorFromUrl

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          minWidth: 400,
          textAlign: 'center',
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#007f98' }}>
            🛠️ Evo Platform Toolkit
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Sign in with your Poolwerx Google account to continue
          </Typography>
        </Box>

        {displayError && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {displayError === 'OAuth not configured. Please contact administrator.' && (
              <>
                <strong>Authentication System Not Configured</strong>
                <br />
                Please contact your system administrator to configure Google OAuth.
              </>
            )}
            {displayError === 'Access not authorized. Please contact support.' && (
              <>
                <strong>Access Not Authorized</strong>
                <br />
                Your account does not have access to this application. Please contact support.
              </>
            )}
            {displayError === 'Authentication disabled in development mode. Set SKIP_AUTH=false to enable.' && (
              <>
                <strong>Authentication Disabled</strong>
                <br />
                Authentication is disabled in development mode. Contact your developer to enable it.
              </>
            )}
            {!displayError.includes('OAuth not configured') && 
             !displayError.includes('Access not authorized') && 
             !displayError.includes('Authentication disabled') && (
              <>
                <strong>Authentication Error</strong>
                <br />
                {displayError}
              </>
            )}
          </Alert>
        )}

        <Button
          variant="contained"
          size="large"
          onClick={handleLogin}
          disabled={loading}
          startIcon={<GoogleIcon />}
          sx={{
            backgroundColor: '#007f98',
            '&:hover': {
              backgroundColor: '#006680',
            },
            padding: '12px 30px',
            fontSize: '16px',
          }}
        >
          {loading ? 'Signing in...' : 'Sign in with Google'}
        </Button>

        <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid #e0e0e0' }}>
          <Typography variant="caption" color="textSecondary">
            Version {APP_VERSION}
          </Typography>
        </Box>

      </Paper>
    </Box>
  )
}